(() => {
  function initialize() {
    const box = document.getElementById('bd-buybox');
    const details = box?.closest('.product-details');
    const title = details?.querySelector('h1')?.closest('.text-block');
    const description = details?.querySelector('.text-block[class*="__text_desc"]');
    const finish = document.getElementById('bdbb-finish');
    const field = finish?.closest('.bd-buybox__field');
    if (!box || !title || !description || !field || details.dataset.mobileFinishPreview) return;
    details.dataset.mobileFinishPreview = 'ready';
    description.classList.add('bd-mobile-product-description');

    const position = element => {
      const marker = document.createComment('Original product layout position');
      element.before(marker);
      return marker;
    };
    const boxPosition = position(box);
    const descriptionPosition = position(description);
    const fieldPosition = position(field);
    const label = document.getElementById('bdbb-finish-label');
    const selectedName = document.createElement('span');
    selectedName.className = 'bd-mobile-selected-finish';
    selectedName.setAttribute('aria-live', 'polite');
    label?.append(selectedName);

    function updateSelectedFinish() {
      const selected = finish.querySelector('[aria-checked="true"]')?.dataset.finish;
      const text = selected ? ` — ${selected}` : '';
      if (selectedName.textContent !== text) selectedName.textContent = text;
    }
    new MutationObserver(updateSelectedFinish).observe(finish, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['aria-checked'],
    });

    const mobile = window.matchMedia('(max-width: 749px)');
    function updateLayout() {
      if (mobile.matches) {
        box.prepend(field);
        title.after(box);
        box.after(description);
        details.classList.add('bd-mobile-product-layout');
      } else {
        fieldPosition.after(field);
        descriptionPosition.after(description);
        boxPosition.after(box);
        details.classList.remove('bd-mobile-product-layout');
      }
    }
    updateSelectedFinish();
    updateLayout();
    mobile.addEventListener('change', updateLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, {once: true});
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', initialize);
})();
